import { Controller } from "@hotwired/stimulus"

// Story F — listens for clicks on .tree-node__quick-add elements and opens
// the people-new drawer with the relation pre-filled. Works in concert with
// the TreeGraphController which already owns the drawer.
export default class extends Controller {
  static values = { treeId: Number }

  connect() {
    this._onClick = this.onQuickAddClick.bind(this)
    this.element.addEventListener("click", this._onClick, true)
  }

  disconnect() {
    if (this._onClick) {
      this.element.removeEventListener("click", this._onClick, true)
      this._onClick = null
    }
  }

  onQuickAddClick(event) {
    const btn = event.target.closest(".tree-node__quick-add")
    if (!btn) return
    event.preventDefault()
    event.stopPropagation()
    const personId = btn.getAttribute("data-person-id")
    const relationKind = btn.getAttribute("data-relation-kind")
    if (!personId || !relationKind) return
    const url = `/trees/${this.treeIdValue}/people/new?` +
                `relation_to_person_id=${personId}&relation_kind=${relationKind}`
    this.dispatch("open", { detail: { url } })
  }
}
